import SettingsControlPanel from '@/components/programSettings/SettingsControlPanel';
import { PROGRAM_SETTINGS } from '@/constants/programSettings';
import { Stack, Typography } from '@mui/material';
import { SVButton } from '@/components/core';
import { FormProvider } from 'react-hook-form';
import { useProgramSettingsForm } from '@/hooks/useProgramSettingsForm';
import { SETTINGS_SECTIONS } from '@/components/programSettings/SettingsSections';

export default function ProgramSettingsGeneral() {
  const { formMethods, handleSubmitSetting, isFormDirty } =
    useProgramSettingsForm();
  const SETTINGS_HEADER = PROGRAM_SETTINGS.GENERAL_SETTINGS_HEADER;
  return (
    <>
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(handleSubmitSetting)}>
          <Stack spacing={3} mb={3}>
            <Typography variant="h4" fontWeight="bold">
              {SETTINGS_HEADER}
            </Typography>
            {SETTINGS_SECTIONS.map(section => {
              const SectionComponent = section.component;
              return (
                <SettingsControlPanel
                  key={section.title}
                  controlGroupTitle={section.title}
                  controlGroupDescription={section.description}>
                  <SectionComponent />
                </SettingsControlPanel>
              );
            })}
          </Stack>
          <Stack direction="row" spacing={3} justifyContent="flex-start">
            <SVButton type="submit" variant="primary" disabled={!isFormDirty}>
              Save
            </SVButton>
          </Stack>
        </form>
      </FormProvider>
    </>
  );
}
